import { Fragment } from "react";
import { Avatar, createStyles, Divider, makeStyles, Theme, Typography } from "@material-ui/core";
import MdiIcon from "../../../../components/Shared/MdiIcon";
import { mdiConnection } from "@mdi/js";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        avatar: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            width: '75px',
            height: '75px',
            margin: '16px auto'
        },
        divider: {
            width: '90%',
            margin: '30px auto',
        },
        marginTop: {
            marginTop: theme.spacing(2)
        }
    })
);

interface AdminInvitationHeaderProps {
    organizationName: string;
    hideDivider?: boolean;
}

export const AdminInvitationHeader = observer((props: AdminInvitationHeaderProps) => {

    /********* React hooks *********/

    const classes = useStyles();

    /********* Render *********/

    return (
        <Fragment>
            <Avatar className={classes.avatar}>
                <MdiIcon iconPath={mdiConnection} fontSize='large' />
            </Avatar>
            <Typography variant="h4">
                Let's get plugged in!
            </Typography>
            <Typography className={classes.marginTop}>
                You've been invited to become an admin user for {props.organizationName}.
            </Typography>
            {props.hideDivider ? null : <Divider className={classes.divider} />}
        </Fragment>
    );
});
